/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EmployeeApi } from '../api/employee.api';
import { switchMap, map } from 'rxjs/operators';
import { EmployeeData, Employee } from '../../../interfaces/masters/employee';

@Injectable()
export class EmployeeService extends EmployeeData {

  constructor(private api: EmployeeApi) {
    super();
  }

//   fireRequest(data: Department, method: string) {
//     const links = data.links
//         ? data.links.find(x => x.method === method)
//         : null;
//     switch (method) {
//         case 'DELETE': {
//             return this.api.delete(links.href);
//         }
//         case 'POST': {
//             return this.api.add(links.href,data);
//         }
//         case 'PUT': {
//             return this.api.update(links.href, data);
//         }
//         default: {
//             console.log(`${links.method} not found!!!`);
//             break;
//         }
//     }
// }

reflist(url: string): Observable<Employee[]> {
  return this.api.reflist(url);
}

  list(url: string): Observable<Employee[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Employee>{
      return this.api.getById(url);
  }

  create(url: string, data:Employee): Observable<Employee> {
    return this.api.add(url,data);
  }

  update(url: string, data:Employee): Observable<Employee> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
